import { create } from "sheetly";
export let text = "table.table td,table.table th{border:var(--bs-border-width) var(--bs-border-color) var(--bs-border-style)}table.table th{background-color:var(--bs-table-striped-bg)}";
export const sheet = create(text, import.meta.url);
